import React from "react";
import { GetUserFullName } from "helpers";
import { withAppContext } from "@ctsu/loader";
import { TE, httpStatusEnum } from "appconstants";
import { GridTable } from "@ctsu/ctsu-mui-grid";
import { useSelector, useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';
import { saveArmsData } from 'actions/protocols/protocoldetail';
import { CanUserEditArmCohorts, CanUserAddArmCohorts } from "appconstants/Permission";
import { bindLogger } from 'helpers/BindLogger';
import { openSnackbar } from 'helpers/Notifier';
import { ArmsGridCols } from "../../gridcolumns";
import EditArmRow from "./ArmsForm";
import { useCanEditProtocol, useEditableArmsFields } from "./userRoleHooks";


const ArmsGrid = (props) => {
  const {
    data,
    highlightObj,
    setHighlighted,
    onLoad,
    rowClick,
    handleHistory,
    selectedCohort,
    loadStatusRecords,
    context
  } = props;

  const hasEditPermission= CanUserEditArmCohorts();
  const hasAddPermission= CanUserAddArmCohorts();
  const dispatch = useDispatch();
  const prtInfo = useSelector(state => state.prtDetails.prtInfo);
  const action = bindActionCreators({ saveArmsData }, dispatch);

  const candEditThisProtocol = useCanEditProtocol(prtInfo?.leadGrp)
   const canEditArmsCohort = hasEditPermission && candEditThisProtocol
   const canAddArmsCohort = hasAddPermission && candEditThisProtocol

  const editableArmsFields = useEditableArmsFields(
    prtInfo?.activatedDate
  );

  const saveArms = (armsObj, setEditing) => {
    bindLogger(action.saveArmsData, context)(armsObj)
      .subscribe(resp => {
        if (resp.status === httpStatusEnum.SUCCESS) {
          setEditing(false);
          openSnackbar({
            message: 'Arms saved successfully.',
            variant: 'success',
            name: 'versions'
          });
        }
      });
  };

  const RenderEditRow = (row, setEditing) => {
    return(
      <EditArmRow
          row={row}
          editableFields={editableArmsFields}
          saveHandler={saveArms}
          prtId={prtInfo.prtId}
          setEditing={setEditing}
          selectedCohort={selectedCohort}
          armData={selectedCohort?.arms}
          loadStatusRecords={loadStatusRecords}
      />
    )
  };

  return (
    <GridTable
      tag={`${TE.ID}strata${TE.TABLE}`}
      title={`Arms for Cohort ${selectedCohort?.cohortName || ""}`}
      id="ArmsDataGrid"
      rows={data}
      rowEvents={[handleHistory]}
      rowEditable={(row) => canEditArmsCohort}
      editable={canEditArmsCohort}
      editMode={canEditArmsCohort}
      allowAddRow={canAddArmsCohort && editableArmsFields?.canAddArm}
      columns={ArmsGridCols}
      user={GetUserFullName()}
      recordPerPage={5}
      enableToolbar
      onDataLoad={onLoad}
      addRowLabel="Arms"
      renderEditRow={RenderEditRow}
      highlightRowObject={highlightObj}
      onFilter={(object, field) => {
        setHighlighted(field);
      }}
      exportable={false}
      onRowClicked={rowClick}
      toPdf={false}
    />
  );
};
export default withAppContext(ArmsGrid);
